import React from 'react'
import './list-events.css'



const ListEvents = props => {
    const lines = props.maxLines * 22 + 44

    return (
        <div className='list-events' style={{maxHeight: `${lines}px`}}>
            <h6 className='list-events-title'>{props.title}</h6>
            <div className='list-events2'>
                {props.list.map((d, i) => {
                    return (
                        <div className={`list-events-rows text-center`} key={i}>
                            <p className='list-events-row-title text-truncate'>{d.label}</p>
                            <p className={`progress-bar ${i === 0 ? 'top-progress' : null} ${i + 1 === props.list.length ? 'bottom-progress' : null}`} style={{ width: 100, backgroundColor: d.color.rgb }}><span className='progress-bar-value' style={{ color: d.color.dark ? 'white' : 'black' }}>{d.value}</span></p>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ListEvents